<template>
  <div class="referred">
    <v-row class="">
      <v-col cols="12">
        <v-btn v-if="editable==1" color="primary" style="border-radius: 0px;margin-top: 2px;width: 100%"

               v-on:click="dialog_model=true">{{ $t('addNewProduct') }}
        </v-btn>
      </v-col>
    </v-row>

    <v-card-text>
      <div style="margin-top: 50px">
        <div class="req-list">
          <div class="req-card" v-for="(item,index) in list" :key="item.Id">
            <div>

              <div class="flex-no-wrap justify-space-between">
                <div @click="delete_dialog(item.Id)">
                  <v-row>
                    <v-col cols="4">
                      <div
                        class="req-name"
                        v-text="item.ProductName"
                      ></div>
                    </v-col>
                    <v-col cols="4">
                    <span class="req-code">
                    <span class="bold">{{ item.Qty }} {{ $t('numbers') }}
                    </span>
                  </span>
                    </v-col>
                    <v-col cols="4">
                     <span class="req-code">
                    <span class="bold">{{ get_currency(item.UnitPrice) }} تومان</span>
                  </span>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </v-card-text>
    <v-row class="">
      <v-col cols="12">
        <v-btn v-if="master_id==0 && list.length" color="primary" style="border-radius: 0px;width: 100%"
               v-on:click="add_factor()">ثبت فاکتور
        </v-btn>

      </v-col>
      <v-col cols="12">
        <v-btn v-if="editable==1 && master_id!=0" color="primary" style="border-radius: 0px;width: 100%"
               v-on:click="add_factor_final()">نهایی کردن فاکتور
        </v-btn>
      </v-col>
      <v-col cols="12" v-if="editable==0 && master_id!=0">
        <InformherAttachments :doc_type="$route.params.doc_type" :master_id="master_id"/>
<!--        <v-btn v-if="editable==0 && master_id!=0" color="primary" style="border-radius: 0px;width: 100%"-->
<!--               v-on:click="go_to_attachments()">پیوست های فاکتور-->
<!--        </v-btn>-->
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-dialog
        v-model="dialog_model"
        max-width="290"
        fullscreen
        hide-overlay
      >

        <v-card class="category-modal">
          <v-card-title class="headline">{{ $t('addProduct') }}</v-card-title>
          <v-card-text>
            <v-row>
              <v-row>
                <v-col class="p-1">

                  <treeselect
                    :multiple="false"
                    :load-options="load_models"
                    :normalizer="normalizer_models"
                    :async="true"
                    :placeholder="$t('searchProduct')"
                    v-model="auto_complete_model"
                  />
                </v-col>
              </v-row>

              <v-row>

                <v-col cols="4">
                  <v-text-field
                    :placeholder="$t('count')"
                    type="number"
                    v-model="product_count"/>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    placeholder="قیمت"

                    v-model="product_price"/>
                </v-col>

              </v-row>

            </v-row>
          </v-card-text>
          <v-card-actions class="">
            <v-spacer></v-spacer>

            <v-btn
              class="cancle-btn"
              text
              @click="dialog_model = false"
            >{{ $t('cancel') }}
            </v-btn>
            <v-btn

              class="accept-btn"
              text
              @click="add_model_to_list()"
            >{{ $t('ok') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="delete_dialog_modal"
        persistent
        max-width="290"
      >

        <v-card>
          <v-card-title class="headline">{{ $t('deleteProduct') }}</v-card-title>
          <v-card-text>{{ $t('sureToDeleteProduct') }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="delete_dialog_modal = false"
            >{{ $t('no') }}
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="delete_detail_item()"
            >{{ $t('yes') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>

</template>
<script>
import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import axios from 'axios'
import Vue from 'vue'

import {bus} from '../../../main'
import InformherAttachments from "./InformherAttachments.vue";
const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}
export default {
  props: [
    'passing_data'
  ],
  data() {
    return {
      editable: 0,
      master_id: 0,
      auto_complete_model: null,
      search_entries: [],
      model_txt: '',

      delete_dialog_modal: false,
      status_form: 0,
      dialog_model: false,
      product_count: '',
      product_price: '',
      product_items: [],

      branch_id: 0,
      list: [],
      errors: [],
      selected_post: 0,
      selected_branch: 0,
      // request_items: [],
      // last_request_items: [],
      show_loading: false,
      no_info: true,
      page: 0,
      normalizer_models(node) {
        return {
          id: node.ProductId,
          label: node.ProductName,
        }
      },
      first: true,
    }
  },
  computed: {},
  components: {Treeselect,
    InformherAttachments},
  watch: {
    auto_complete_model() {
      for (var i = 0; i < this.search_entries.length; i++) {
        if (this.search_entries[i].ProductId == this.auto_complete_model) {
          this.model_txt = this.search_entries[i].ProductName
        }
      }
    },
    'product_price':function (){
      this.product_price = this.get_currency(this.product_price.toString().replace(/,/g, ""))
    }
  },
  mounted() {
    this.editable = this.$route.params.editable;
    this.master_id = this.$route.params.master_id;
    // this.$route.params.master_id = 'sadsasdasd'


    if (this.master_id != 0) {
      this.get_factors()
    }
    this.get_branch_permission()

    this.selected_post = parseInt(localStorage.getItem('selected_post'))
  },

  methods: {
    delete_dialog(index) {
      if (this.editable == 1) {
        this.delete_dialog_modal = true
        this.status_form = index
      }
    },
    load_models({action, searchQuery, callback}) {
      this.model_txt = searchQuery
      this.auto_complete_model = null
      var self = this
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options

          var passing_data = JSON.parse(localStorage.getItem('request_data'))
          var url = {}
          var send_data = {}
          if (self.$route.params.doc_type == '156') {
            send_data = {
              CostCenterId: self.$route.params.rec_id,
              Searchtxt: searchQuery,
            }
            url = "/GetBatchItems"
          } else {
            send_data = {
              MainProductId: 0,
              TxtSearch: searchQuery,
            }
            url = "/GetProductLowInfosByKeword"

          }

          this.axios.post(url, send_data, {})
            .then(response => {
              if (self.$route.params.doc_type == '156') {
                self.search_entries = response.data.vmList
                options = response.data.vmList

              } else {
                self.search_entries = response.data.products
                options = response.data.products

              }
              callback(null, options)
              // this.$router.push({ path: "/post-login", params: {} });
            }).catch(e => {
            this.errors.push(e)
          })
        })
      }
    },

    add_model_to_list() {
      if (this.auto_complete_model != null && this.product_count != 0 && this.product_count != '' && this.product_price != 0 && this.product_price != '') {
        this.list.push({
          ProductId: this.auto_complete_model,
          Qty: this.product_count,
          UnitPrice: this.toEnglishDigits(this.product_price.toString().replace(/,/g, "")),
          ProductName: this.model_txt
        })
        this.dialog_model = false
        this.auto_complete_model = null
        this.product_count = ''
        this.product_price = ''
        if (this.master_id != 0) {
          this.add_factor_detail(this.list.length - 1)
        }
      }
    },
    get_factors() {
      // this.request_items = [];
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        UserId: user_id,
        MasterId: this.master_id,
      }

      console.log('pre request called')
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/GetCustomerDetailFacts', send_data, {})
        .then(response => {
          self.last_request_items = []
          if (response.data.error == 0) {
            self.list = response.data.items
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    get_branch_permission() {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      var party_id = localStorage.getItem('party_id')

      const send_data = {
        UserId: user_id,
        Role: 'BranchDefinition',
        PartyId: party_id,
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/ZkGetUserPermission', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            this.branch_id = response.data.UserBranchId
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },

    add_factor() {
      if (this.list.length == 0) {
        bus.$emit('show_toast', [1500, "حداقل یک کالا انتخاب کنید"])
        return
      }
      // this.request_items = [];
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId

      const send_data = {
        RequestId: this.$route.params.rec_id,
        ReqName: "",
        UserId: user_id,
        BranchId: localStorage.getItem("branch_id"),
        DocNo: this.$route.params.doc_type,
        DocDate: "",
        DocDescription: "",
      }

      console.log('pre request called')
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/AddMasterFactor', send_data, {})
        .then(response => {
          self.last_request_items = []
          if (response.data.error == 0) {
            self.master_id = response.data.MasterId

            // self.$route.params.master_id = response.data.MasterId
            // const currentParams = self.$router.currentRoute.params;
            // const mergedParams = { ...currentParams, master_id:self.master_id };
            // self.$router.push({ params: mergedParams });

            self.add_factor_detail(0)
            // bus.$emit('show_toast', [1500, response.data.msg])
            // self.$router.go(-1)
          } else {
            bus.$emit('show_toast', [1500, response.data.msg])
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    go_to_attachments() {
      this.$router.push({path: '/report-request/informher-attachments/' + this.$route.params.rec_id + '/' + this.master_id + '/' + this.$route.params.doc_type})
    },
    add_factor_final() {
      // this.request_items = [];
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId

      const send_data = {
        RequestId: this.$route.params.rec_id,
        UserId: user_id,
        DocType: this.$route.params.doc_type,
        MasterId: this.master_id,
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/AddFactorToFinal', send_data, {})
        .then(response => {
          self.last_request_items = []
          if (response.data.error == 0) {
            self.master_id = response.data.MasterId

            // self.add_factor_detail(0)
            bus.$emit('show_toast', [1500, response.data.msg])
            self.editable=0
          } else {
            bus.$emit('show_toast', [1500, response.data.msg])
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    add_factor_detail(index) {
      // this.request_items = [];
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId

      const send_data = {
        MasterId: this.master_id,
        RequestId: this.$route.params.rec_id,
        Qty: this.list[index].Qty,
        Summary: "",
        UnitPrice: this.list[index].UnitPrice,
        TotalPrice: this.list[index].Qty * this.list[index].UnitPrice,
        ProductId: this.list[index].ProductId,
        UserId: user_id,
      }
      console.log('pre request called')
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/AddDetailFactor', send_data, {})
        .then(response => {
          self.last_request_items = []
          if (response.data.error == 0) {
            if (index < self.list.length - 1) {
              self.add_factor_detail(index + 1)
            } else {
              bus.$emit('show_toast', [1500, response.data.msg])
              // self.$router.go(-1)
            self.get_factors()
            }
          } else {
            bus.$emit('show_toast', [1500, response.data.msg])
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    delete_factor_detail() {
      // this.request_items = [];
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId

      const send_data = {
        MasterId: this.master_id,
        RecId: this.status_form,
        UserId: user_id,
      }
      this.status_form = 0;

      // this.axios.post('/Register' , send_data,{
      this.axios.post('/DeleteDetailFactor', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            self.get_factors();
          } else {
            bus.$emit('show_toast', [1500, response.data.msg])
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    delete_detail_item() {
      // this.request_items = [];
      this.delete_dialog_modal = false
      if (this.master_id == 0) {
        this.list.splice(this.status_form, 1)
        this.status_form = 0;
      } else {
        this.delete_factor_detail();
      }
    },

  }
}
</script>
<style>
.v-application .headline {
  font-size: 1rem !important;
  font-weight: 400;
  line-height: 2rem;
  letter-spacing: normal !important;
  font-family: "IRANSans" !important;
}
</style>
